// Convert date to UTC
const toUTCDate = (dateString: string): Date => {
    const date = new Date(dateString);
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};

export function formatDate(dateString:string) {
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const inputData = new Date(dateString)
    const day = inputData.getDate()
    const month = months[inputData.getMonth()]
    const year = inputData.getFullYear()
    const dayOfWeek = days[inputData.getDay()]
    const formattedDate = `${dayOfWeek}, ${month} ${day}, ${year}`
    return formattedDate
} 

export function formatTime(dateString:string) {
    const inputData = toUTCDate(dateString)
    let hours = inputData.getHours() % 12 || 12
    let minutes = inputData.getMinutes()
    let ampm = inputData.getHours() < 12 ? 'am' : 'pm'
    const formattedMinutes = String(minutes).padStart(2,'0')
    const formattedTime = `${hours}:${formattedMinutes}${ampm.toUpperCase()}`
    return formattedTime
}